module.exports = __webpack_public_path__ + "img/checkIcon.c0cc2271.svg";